import { MaybePromise } from './promise';

/**
 * Defer the execution of a function by scheduling it for the next available macro task in
 * the event loop.
 */
export function defer(fn: () => any) {
  setTimeout(fn);
}

/**
 * Ignore any error thrown while executing the passed function.
 */
export function ignoreError(fn: () => any) {
  try {
    fn();
  } catch (err) {
    console.warn('[ignoreError]', err);
  }
}

/**
 * Ignore any error thrown while executing the passed asycn function.
 */
export async function ignoreErrorAsync(fn: () => MaybePromise<any>) {
  try {
    await fn();
  } catch (err) {
    console.warn('[ignoreError]', err);
  }
}

export function noop(..._args: any[]) {}
